import { AlertOctagon, AlertTriangle, Info } from 'lucide-react';
import type { AlertSeverity } from '@iot-dashboard/shared';

const ICON = { critical: AlertOctagon, warning: AlertTriangle, info: Info } as const;

export function SeverityBadge({ severity }: { severity: AlertSeverity }) {
  const Icon = ICON[severity] ?? Info;
  return (
    <span className={`badge badge--${severity}`}>
      <Icon size={12} aria-hidden="true" />
      {severity}
    </span>
  );
}
